export const SET_NOTIFICATIONS_LIST_VISIBLE =
  'app/Notifications/SET_NOTIFICATIONS_LIST_VISIBLE';

export const ON_UNREAD_NOTIFICATIONS_FETCHED_RECEIVE =
  'app/Notifications/ON_UNREAD_NOTIFICATIONS_FETCHED_RECEIVE';

export const ON_NEW_NOTIFICATION_RECEIVE =
  'app/Notifications/ON_NEW_NOTIFICATION_RECEIVE';

export const MARK_NOTIFICATION_READ_LOCALLY =
  'app/Notifications/MARK_NOTIFICATION_READ_LOCALLY';

export const SET_NAVIGATOR_AVAILABILITY_LOCALLY =
  'app/Notifications/SET_NAVIGATOR_AVAILABILITY_LOCALLY';
